export default __webpack_public_path__ + "assets/models/069144dbfb20b9bc559d0a838f009516.glb";